const tabs = {
  PROJECT: 'project',
  HIGHLIGHT_REEL: 'Highlight Reel',
  TAGS: 'Tags',
  SEARCH: 'search',
};

export default tabs;
